import { Slider, ColorPicker, InputNumber } from 'antd';
import { useSketchProperitesContext } from '../../../../../context/SketchPropertiesContext';
import { Fragment } from 'react/jsx-runtime';
import './SketchConfig.scss';

const PolygonConfig = () => {
  const { fill, fillOpacity, outline, outlineWeight, outlineOpacity, setState } = useSketchProperitesContext();

  return (
    <Fragment>
      {/* Line Colour*/}
      <div className="sketch-config__row">
        <span className="sketch-config__label">STROKE COLOR</span>
        <ColorPicker
          value={outline}
          onChange={(value) => {
            setState((prev) => ({
              ...prev,
              outline: value.toHexString(),
            }));
          }}
          showText
        />
      </div>

      {/* Line weight */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">STROKE WIDTH</span>
        <Slider className="sketch-config__flex" value={outlineWeight} onChange={(value) => setState((prev) => ({ ...prev, outlineWeight: value }))} />
        <InputNumber
          className="sketch-config__input"
          value={outlineWeight}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              outlineWeight: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="px"
        />
      </div>

      {/* Line Opacity */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">OPACITY</span>
        <Slider
          className="sketch-config__flex"
          value={outlineOpacity}
          onChange={(value) => setState((prev) => ({ ...prev, outlineOpacity: value }))}
        />
        <InputNumber
          className="sketch-config__input"
          value={outlineOpacity}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              outlineOpacity: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="%"
        />
      </div>

      {/* Fill */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">FILL</span>
        <ColorPicker
          value={fill}
          onChange={(value) => {
            setState((prev) => ({
              ...prev,
              fill: value.toHexString(),
            }));
            console.log('fill: ', value);
          }}
          showText
        />
      </div>

      {/* Fill Opacity */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">FILL OPACITY</span>
        <Slider className="sketch-config__flex" value={fillOpacity} onChange={(value) => setState((prev) => ({ ...prev, fillOpacity: value }))} />
        <InputNumber
          className="sketch-config__input"
          value={fillOpacity}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              fillOpacity: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="%"
        />
      </div>
    </Fragment>
  );
};

export default PolygonConfig;
